import React, {useContext, useEffect} from "react";
import UserDropdown from "../Dropdowns/UserDropdown";
import {UsePermissions} from "../../hooks/usePermissions";

import {AppContext} from "../../context/appContext";
import {SearchMenu} from "./components/SearchMenu";
import {types} from "../../shared/types/types";


export default function Navbar() {
    const [permisos] = UsePermissions();
    const {user} = useContext(AppContext);
    const { dispatch} = useContext(AppContext);

    const openMenu = () => {
        const action = {
            type: types.showMenu,
            payload: true
        }
        dispatch(action)
    }
    return (
        <>
            {/* Navbar */}
            <nav
                className="absolute top-0 left-0 w-full z-10 bg-transparent md:flex-row md:flex-nowrap md:justify-start flex items-center p-4">
                <div
                    className="w-full mx-auto items-center flex justify-between md:flex-nowrap flex-wrap md:px-10 px-4">
                    <div className={'w-full'}>
                        {/* Brand */}
                        <button
                            className="mt-3 cursor-pointer text-white  opacity-50 mr-5 py-1 text-xl leading-none bg-transparent focus-visible:border-transparent rounded border border-solid border-transparent"
                            type="button"
                            onClick={() => openMenu()}
                        >

                            <i className="fas fa-bars "/>
                        </button>
                        <a
                            className="text-white text-sm uppercase hidden lg:inline-block font-semibold"
                            href="#pablo"
                            onClick={(e) => e.preventDefault()}
                        >
                            {permisos.submenu} - {user.name}
                        </a>
                    </div>

                    {/* Form */}
                    <div className="md:flex hidden flex-row flex-wrap items-center lg:ml-auto mr-3">
                        <div className="relative flex w-full flex-wrap items-stretch">
              <span
                  className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
                {/*<i className="fas fa-search"/>*/}
              </span>
                            <SearchMenu/>
                        </div>
                    </div>
                    {/* User */}
                    <ul className="flex-col md:flex-row list-none items-center hidden md:flex">
                        <UserDropdown/>
                    </ul>
                </div>
            </nav>
            {/* End Navbar */}
        </>
    );
}
